import React, { useEffect } from "react";
import {Accordion, AccordionDetails, AccordionSummary, Grid, Typography, useTheme} from "@mui/material";
import {ExpandMore} from "@mui/icons-material";
import {useTranslation} from "react-i18next";
import {useFormContext} from "react-hook-form";
import {IRaDetailView} from "../../models/models";
import {FormCheckbox, FormTextField} from "../../common/form-fields-wrappers";
import {useRecoilValue} from "recoil";
import {raDetailState} from "../state";
import { formatCurrency } from "../../utils";
import { LOCALES } from "../../config";
import { locale } from "dayjs";

const QuotationInfo = () => {
    const {t} = useTranslation(['network', 'translation']);
    const theme = useTheme();
    const raDetail = useRecoilValue(raDetailState);
    const raDetailForm = useFormContext<IRaDetailView>();

    useEffect(() => {
        if (!!raDetail) {
            // @ts-ignore
            raDetailForm.setValue('quotationInfo.discountsApplied', formatCurrency(locale as LOCALES, raDetail?.quotationInfo?.appliedDiscounts));
        }
    }, [raDetail]);

    return (
        <Accordion>
            <AccordionSummary expandIcon={<ExpandMore />}>
                <Typography variant={"bodyLarge"}>
                    {t("raDetail.quotationInfo.accordion.title")}
                </Typography>
            </AccordionSummary>

            <AccordionDetails>
                <Grid container columnSpacing={2}>
                    <Grid item xs={12} sx={{display: "flex", alignItems: "center"}}>
                        <FormCheckbox<IRaDetailView>
                            name={`quotationInfo.reservedTariffs`}
                            label={t("raDetail.quotationInfo.form.label.reservedTariffs")}
                            color={'primary'}
                            disabled
                            sx={{color: theme.palette.primary.main}}
                        />
                    </Grid>

                    <Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                        <FormTextField<IRaDetailView>
                            name='quotationInfo.rentalAmount'
                            control={raDetailForm.control}
                            label={t("raDetail.quotationInfo.form.label.rentalAmount")}
                            fullWidth
                            disabled
                        />
                    </Grid>

                    <Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                        <FormTextField<IRaDetailView>
                            name='quotationInfo.bookedAncillariesAmount'
                            control={raDetailForm.control}
                            label={t("raDetail.quotationInfo.form.label.bookedAncillariesAmount")}
                            fullWidth
                            disabled
                        />
                    </Grid>

                    <Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                        <FormTextField<IRaDetailView>
                            name='quotationInfo.addedAncillariesAmount'
                            control={raDetailForm.control}
                            label={t("raDetail.quotationInfo.form.label.addedAncillariesAmount")}
                            fullWidth
                            disabled
                        />
                    </Grid>

                    {
                        raDetail?.quotationInfo?.appliedDiscounts !== 0 &&
                        <Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                            <FormTextField<IRaDetailView>
                                name='quotationInfo.discountsApplied'
                                control={raDetailForm.control}
                                label={t("raDetail.quotationInfo.form.label.discountsApplied")}
                                fullWidth
                                disabled
                            />
                        </Grid>
                    }


                    <Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                        <FormTextField<IRaDetailView>
                            name='quotationInfo.totalAmountTaxIncluded'
                            control={raDetailForm.control}
                            label={t("raDetail.quotationInfo.form.label.totalAmountTaxIncluded")}
                            fullWidth
                            disabled
                        />
                    </Grid>

                    <Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                        <FormTextField<IRaDetailView>
                            name='quotationInfo.airportTax'
                            control={raDetailForm.control}
                            label={t("raDetail.quotationInfo.form.label.airportTax")}
                            fullWidth
                            disabled
                        />
                    </Grid>

                    <Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                        <FormTextField<IRaDetailView>
                            name='quotationInfo.railwayTax'
                            control={raDetailForm.control}
                            label={t("raDetail.quotationInfo.form.label.railwayTax")}
                            fullWidth
                            disabled
                        />
                    </Grid>

                    <Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                        <FormTextField<IRaDetailView>
                            name='quotationInfo.roadTax'
                            control={raDetailForm.control}
                            label={t("raDetail.quotationInfo.form.label.roadTax")}
                            fullWidth
                            disabled
                        />
                    </Grid>

                    <Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                        <FormTextField<IRaDetailView>
                            name='quotationInfo.totalAmountTaxExcluded'
                            control={raDetailForm.control}
                            label={t("raDetail.quotationInfo.form.label.totalAmountTaxExcluded")}
                            fullWidth
                            disabled
                        />
                    </Grid>

                    <Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                        <FormTextField<IRaDetailView>
                            name='quotationInfo.damageExcess'
                            control={raDetailForm.control}
                            label={t("raDetail.quotationInfo.form.label.damageExcess")}
                            fullWidth
                            disabled
                        />
                    </Grid>

                    <Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                        <FormTextField<IRaDetailView>
                            name='quotationInfo.fireTheftExcess'
                            control={raDetailForm.control}
                            label={t("raDetail.quotationInfo.form.label.fireTheftExcess")}
                            fullWidth
                            disabled
                        />
                    </Grid>
                </Grid>
            </AccordionDetails>
        </Accordion>
    );
}

export default QuotationInfo;